import { ReactElement } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import { Box, IconButton } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

// Components
import { FormikInputField } from 'components/forms';

// Styles
import styles from 'components/Facets/FacetSearch.module.scss';

// Types
import { FormikInputFieldProps } from '../types';

export const FormikInputFieldWithSearch = (props: FormikInputFieldProps): ReactElement => {
  const { formikKey, placeholder, title } = props;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <FormikInputField formikKey={formikKey} placeholder={placeholder} startIcon={<SearchIcon />} title={title} />
      <Box sx={{ ml: -3 }}>
        <IconButton aria-label="search" className={styles['search-icon']} size="medium" type="submit">
          <ArrowForwardIcon />
        </IconButton>
      </Box>
    </Box>
  );
};
